var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TabMenuCom"},_vm._l((_vm.menuList),function(v,i){return _c('p',{key:i,style:({
      borderColor: _vm.$parent.activeName == v?.name ? '#28cccb' : 'transparent',
      color: _vm.$parent.activeName == v?.name ? '#28cccb' : '#666',
    }),on:{"click":function($event){return _vm.changeTab(v)}}},[_vm._v(" "+_vm._s(v?.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }